import JSZip from 'jszip';
import {
  IMAGE_EXPORT_SCALE,
  canvasToBlob,
  captureExportElement,
  downloadBlob,
} from './exportCaptureUtils';
import { buildImageFileName } from './exportFileNames';

export const generateDashboardImages = async ({
  selectedItems,
  filePrefix = 'solution-demo',
  zipFileName = 'solution-demo-analytics-images.zip',
}) => {
  if (!selectedItems.length) {
    throw new Error('Select at least one card to export.');
  }

  const capturedItems = [];

  for (let index = 0; index < selectedItems.length; index += 1) {
    const item = selectedItems[index];
    const element = document.getElementById(item.id);

    if (!element) {
      // eslint-disable-next-line no-continue
      continue;
    }

    // eslint-disable-next-line no-await-in-loop
    const canvas = await captureExportElement(element, IMAGE_EXPORT_SCALE);
    const fileName = buildImageFileName(item, filePrefix);
    // eslint-disable-next-line no-await-in-loop
    const blob = await canvasToBlob(canvas);

    if (!blob) {
      // eslint-disable-next-line no-continue
      continue;
    }

    capturedItems.push({ fileName, blob });
  }

  if (!capturedItems.length) {
    throw new Error('Unable to capture selected cards for export.');
  }

  if (capturedItems.length === 1) {
    downloadBlob(capturedItems[0].blob, capturedItems[0].fileName);
    return;
  }

  const zip = new JSZip();
  capturedItems.forEach(({ fileName, blob }) => {
    zip.file(fileName, blob);
  });

  const zipBlob = await zip.generateAsync({
    type: 'blob',
    compression: 'DEFLATE',
    compressionOptions: { level: 6 },
  });

  downloadBlob(zipBlob, zipFileName);
};
